import { axiosInstance } from './axiosInstance'
import { OFFER, SAVE } from '../../../constants/constants'
import { type APIConfig } from '../apiTypes'

const axios = axiosInstance()

type Response = any

export const postEvent = async <T = any>(args: {
  apiConfigs: APIConfig
  data: {
    customer: any
    yass: {
      configId: string
      configHashKey: string
    }
    type: any
  }
  onSuccess: (response: { data: Response }) => T
}): Promise<T> => {
  const { onSuccess } = args
  const { customer, type } = args.data
  const { marketCode, eventApiBaseUrl } = args.apiConfigs
  const { configId: yassConfigId, configHashKey: yassConfigHashKey } = args.data.yass

  const { path, eventCode } = (() => {
    switch (type) {
      case OFFER:
        return {
          path: 'requestOfferEvent',
          eventCode: 'MOKRequestOffer',
        }
      case SAVE:
        return {
          path: 'saveConfigEvent',
          eventCode: 'MOKSaveConfig',
        }
      default:
        console.error('Unexpected type in postEvent')
        return { path: null, eventCode: null }
    }
  })()

  if (!path || !eventCode) throw new Error('missing path or eventCode')

  return await axios<Response>({
    method: 'post',
    url: `${eventApiBaseUrl}/${path}/${eventCode}`,
    ...(import.meta.env.VITE_SCENSUM_ENV !== 'production' && {
      headers: { TestMode: 'TEST' },
    }),
    data: {
      source: 'NoppeWeb',
      subjectType: 'YASSCONFIG',
      subjectId: yassConfigId,
      marketCode,
      eventData: {
        yassConfigId,
        yassConfigHashKey,
        customer: {
          name: customer.name || null,
          adress: customer.adress || null,
          zipCode: customer.zipCode || null,
          city: customer.city || null,
          country: 'SE',
          erpCusNo: customer.erpCusNo || null,
          cnohash: customer.cnohash || null,
          email: customer.email || null,
          phone: customer.phone || null,
          marketingOptIn: customer.marketingOptIn, // can be null, indicates 'intentionally omitted' to backend
        },
      },
    },
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
